var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h3',{staticClass:"title"},[_vm._v("Projects")]),_c('div',{staticClass:"section"},_vm._l((_vm.projects),function({ title, link, content },index){return _c('Card',{key:index,attrs:{"title":title,"link":link,"content":content}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }